import './errorsList';
import './dataElementsList';
import './utils';
import './api';
import './scormFunctions/initialize';
import './scormFunctions/finish';

// window.API_1484_11 = null;
